import { Pipe, PipeTransform } from '@angular/core';
import { join, List } from 'lodash';

@Pipe({
  name: 'join',
  standalone: true,
})
export class JoinPipe implements PipeTransform {
  transform(value: List<any> | null | undefined, seperator?: string): string {
    return join(value, seperator);
  }
}
